'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Accordion = function (_React$Component) {
  _inherits(Accordion, _React$Component);

  function Accordion(props) {
    _classCallCheck(this, Accordion);

    var _this = _possibleConstructorReturn(this, (Accordion.__proto__ || Object.getPrototypeOf(Accordion)).call(this, props));

    _this.onItemOpen = function (index) {
      var openItems = [].concat(_toConsumableArray(_this.state.openItems));
      if (_this.props.accordion) {
        openItems = openItems[0] === index ? [] : [index];
      } else {
        var idx = openItems.indexOf(index);
        if (idx > -1) {
          openItems.splice(idx, 1);
        } else {
          openItems.push(index);
        }
      }
      if (_this.props.onItemOpen) {
        _this.props.onItemOpen(openItems);
      }
      _this.setState({
        openItems: openItems
      });
    };

    _this.configureState = function (openItems) {
      var state = {
        openItems: []
      };
      if (openItems !== undefined) {
        state.openItems = Array.isArray(openItems) ? openItems : [openItems];
      }
      return state;
    };

    _this.state = _this.configureState(props.openItems);
    _this.onItemOpen = _this.onItemOpen.bind(_this);
    return _this;
  }

  _createClass(Accordion, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (nextProps.openItems && this.state.openItems && (nextProps.openItems.length !== this.state.openItems.length || nextProps.openItems.every(function (element, index) {
        return element !== _this2.state.openItems[index];
      }))) {
        this.setState(this.configureState(nextProps.openItems));
      }
    }
  }, {
    key: 'isOpen',
    value: function isOpen(index) {
      if (this.props.accordion) {
        return this.state.openItems[0] === index;
      }
      return this.state.openItems.indexOf(index) > -1;
    }
  }, {
    key: 'renderAccordionItems',
    value: function renderAccordionItems(children) {
      var _this3 = this;

      if (children) {
        return _react2.default.Children.map(children, function (child, idx) {
          var childProps = {
            idx: idx,
            onItemOpen: _this3.onItemOpen,
            open: _this3.isOpen(idx)
          };
          return _react2.default.cloneElement(child, childProps);
        });
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var accordionClasses = (0, _classnames2.default)('accordion', this.props.className);
      return _react2.default.createElement(
        'div',
        { className: accordionClasses },
        this.renderAccordionItems(this.props.children)
      );
    }
  }]);

  return Accordion;
}(_react2.default.Component);

exports.default = Accordion;


Accordion.propTypes = {
  accordion: _propTypes2.default.bool,
  children: _propTypes2.default.node.isRequired,
  onItemOpen: _propTypes2.default.func.isRequired,
  className: _propTypes2.default.string,
  openItems: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.number), _propTypes2.default.number]).isRequired
};

Accordion.defaultProps = {
  accordion: true,
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/accordion/jsx/Accordion.js
// module id = 671
// module chunks = 4